// 9fbef606107a605d69c0edbcd8029e5d
import {
  APICONFIG_REDUCER_KEY,
  COUNTRY_SELECTOR_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';

import { getIsInternationalCheckoutEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';

export const getCountrySelectorState = (state) => {
  return state[COUNTRY_SELECTOR_REDUCER_KEY];
};

export const getCountriesMap = (state) => {
  const { siteOptions } = state[SESSIONCONFIG_REDUCER_KEY];
  return siteOptions && getIsInternationalCheckoutEnabled(state)
    ? siteOptions.countriesMap
    : siteOptions.countriesMap.filter((c) => c.id === 'US' || c.displayName === 'CANADA');
};

export const getCurrenciesMap = (state) => {
  const { siteOptions } = state[SESSIONCONFIG_REDUCER_KEY];
  return siteOptions && siteOptions.currenciesMap;
};

export const getSitesTable = (state) => {
  const { siteOptions } = state[SESSIONCONFIG_REDUCER_KEY];
  return siteOptions && siteOptions.sitesTable;
};

export const getSelectedCountryName = (state) => {
  return getCountrySelectorState(state)?.get('countryName');
};

export const getCurrentCountry = (state) => {
  return getCountrySelectorState(state)?.get('country');
};

export const getCurrentLanguage = (state) => {
  return getCountrySelectorState(state)?.get('language');
};

export const getCurrentCurrency = (state) => {
  return getCountrySelectorState(state)?.get('currency');
};

export const getCurrentFlag = (state) => {
  return getCountrySelectorState(state)?.get('flag');
};

export const getIsModalOpen = (state) => {
  return getCountrySelectorState(state)?.get('isModalOpen');
};

export const getSiteId = (state) => {
  return getCountrySelectorState(state)?.get('siteId') || state[APICONFIG_REDUCER_KEY].siteId;
};

export const getOldCountry = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY].siteDetails.country;
};

export const getOldCurrency = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY].siteDetails.currency;
};

export const getOldLanguage = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY].siteDetails.language;
};

export const getNoteContent = (state) => {
  return getCountrySelectorState(state)?.get('moduleXContent');
};
